/**
 * Column definitions, in render order. `width` is each column's floor so a
 * value never collapses to a single letter; `locked` columns cannot be hidden
 * because a row is unidentifiable without them.
 *
 * A column with `tagGroup` is one fixed tag group, drawn as one sub-column per
 * tag field under a shared heading. The groups and fields are passed in, so
 * this file stays free of model imports.
 *
 * "Module" is locked to the filter above the grid whenever one module is
 * selected. Publish state is not here: the grid does not own kpi_status.
 */
/**
 * @param {{ tagGroups: { name: string, label: string }[], tagFields: { key: string, label: string }[] }} args
 */
export const buildColumns = ({ tagGroups, tagFields }) => [
  { key: "title", label: "KPI title", width: 300, locked: true },
  { key: "financialYear", label: "Financial year", width: 130 },
  { key: "module", label: "Module", width: 180 },
  { key: "type", label: "Type", width: 180 },
  { key: "kpiType", label: "KPI type", width: 170 },
  { key: "frequency", label: "Frequency", width: 130 },
  { key: "aggregation", label: "Aggregation", width: 140 },
  { key: "category", label: "Category", width: 140 },
  { key: "defaultDescription", label: "Default description", width: 260 },
  { key: "yearDescription", label: "This year description", width: 260 },
  { key: "tableSetup", label: "Table setup", width: 220 },
  { key: "readOnly", label: "Read only", width: 100 },
  ...tagGroups.map((group) => ({
    key: `tag:${group.name}`,
    label: `${group.label} tags`,
    tagGroup: group.name,
    sub: tagFields.map((field) => ({ ...field, width: 150 })),
  })),
  { key: "tags", label: "Other tags", width: 240 },
  { key: "emission", label: "Emission factors", width: 280 },
  { key: "units", label: "Supported units", width: 220 },
  { key: "evidences", label: "Evidence", width: 220 },
  { key: "industries", label: "Industries", width: 190 },
  { key: "frameworks", label: "Frameworks", width: 190 },
  { key: "sectionMapping", label: "Framework section mapping", width: 240 },
  { key: "formula", label: "Formula", width: 240 },
  { key: "variables", label: "Variables", width: 200 },
  { key: "variableUnits", label: "Variable units", width: 200 },
  { key: "applicableCheck", label: "Applicable check", width: 130 },
  { key: "applicableNote", label: "Applicable note", width: 130 },
  { key: "trigerCheck", label: "Trigger check", width: 120 },
  { key: "kpiStatus", label: "KPI status", width: 130 },
  { key: "active", label: "Active", width: 80 },
];

export const spanOf = (column) => (column.sub ? column.sub.length : 1);
